











































































































































// import {getEmployeeList,enableOrDisableEmployee} from '@/api/employee'
import {getClienteleList, deleteClientele} from '@/api/clientele'
// import {getOrderNumber, getExistOrderNumber} from '@/api/consultant'
import router from '@/router';
export default  {
  //模型数据
  data() {
    return {
      loading: false,
      name: '', //学生姓名，对应上面的输入框
      consultantName: '',
      page: 1, //页码
      pageSize: 50, //每页记录数
      total: 0, //总记录数
      records: [], //当前页要展示的数据集合
      multipleSelection: '',
      orderNumber: 0, //剩余客单数
      existOrderNumber: 0, // 现存客单
    }
  },
  created() {
    // this.CheckMac()
    // this.getConsultantOrderNumber()
    // this.getExistConsultantOrderNumber()
    this.pageQuery()
  },
  methods: {

    // 客单数获取
    // getConsultantOrderNumber(){
    //   this.loading = true
    //   getOrderNumber().then(res =>{
    //     if(res.data.code === 1){
    //       this.orderNumber = res.data.data.orderNumber
    //       // alert(this.orderNumber)
    //     }
    //   }).catch(err=>{
    //     this.$message.error('客单数获取失败，请重新登录：' + err.message)
    //   })
    //   this.loading = false
    // },
    // 客单数获取
    // getExistConsultantOrderNumber(){
    //   this.loading = true
    //   getExistOrderNumber().then(res =>{
    //     if(res.data.code === 1){
    //       this.existOrderNumber = res.data.data.existOrderNumber
    //       // alert(this.orderNumber)
    //     }
    //   }).catch(err=>{
    //     this.$message.error('客单数获取失败，请重新登录：' + err.message)
    //   })
    //   this.loading = false
    // },
    //分页查询
    pageQuery() {
      // alert("pageQuery")
      this.loading = true
      //准备请求参数
      const params = {
        stuName:this.name,
        consultantName: this.consultantName,
        page:this.page,
        pageSize:this.pageSize
      }

      //发送Ajax请求，访问后端服务，获取分页数据
      getClienteleList(params).then(res => {
        if(res.data.code === 1) {
          this.total = res.data.data.total
          this.records = res.data.data.records
        }
      }).catch(err => {
        this.$message.error('请求出错了：' + err.message)
      })
      this.loading = false
    },
    //pageSize发生变化时触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageQuery()
    },
    //page发生变化时触发
    handleCurrentChange(page) {
      this.page = page
      this.pageQuery()
    },
    //跳转到新增员工页面（组件）
    handleAddClientele(){
      //路由跳转，跳转到新增员工组件
      this.$router.push('/consultantDashboard/add')
    },

    //跳转到修改员工页面（组件）
    handleUpdateClientele(row) {

      //跳转到修改页面，通过地址栏传递参数
      this.$router.push({
        path: '/clienteles/add',
        query: {id: row.id}
      })
    },
    handlePlanClientele(row){
      //跳转到规划页面，通过地址栏传递参数
      this.$router.push({
        path: '/consultantDashboard/addPlan',
        query: {clienteleId: row.id}
      })
    },
    handleCurrentPlanClientele(row){
      //跳转到规划页面，通过地址栏传递参数
      this.$router.push({
        path: '/consultantDashboard/planGroup',
        query: {clienteleId: row.id, clienteleName: row.stuName}
      })
    },
    handleSimulationClientele(row){
      this.$router.push({
        path: '/simulation',
        query: {clienteleId: row.id}
      })
    },


    // handleDeleteClientele(row){
    //   this.$confirm('删除客单不会返还客单数，是否继续删除？', '警告', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(()=>{
    //     deleteClientele(row.id)
    //     this.$message.success('客单删除成功！')
    //     location.reload()
    //     // this.$router.go(0);
    //     // this.reload()
    //     // this.pageQuery()
    //     // this.getConsultantOrderNumber()
    //     // console.log("pageQuery")
    //     // this.$router.push('/consultantDashboard')
    //   }).catch(()=>{
    //     this.$message({
    //       type: 'info',
    //       message: '已取消操作'
    //     });
    //   })
    // },
    // 多选客单
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('当前表格勾选了几项：' + val.length)
      // val.forEach(element => {
      //   console.log('id=' + element.id)
      // })
    },
    // 删除客单
    handleDelete() {
      if(this.multipleSelection.length<=0) {
        this.$message.warning("未选中客单！")
      }else{
        this.$confirm('确认删除当前指定的客单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const deletePromises = this.multipleSelection.map(element => deleteClientele(element.id));
          // 等待所有请求完成
          await Promise.all(deletePromises);
          //   this.multipleSelection.forEach(async element => {//1,2,3
          //   // arr.push(element.id)
          //   deleteClientele(element.id)
          //
          // })
          // 添加2秒等待
          // await new Promise(resolve => setTimeout(resolve, 800));

          this.$message.success('删除成功！')
          this.pageQuery()

          // this.$router.go(0);

        })
      }

    },
  }
}
